import { createApiClient } from 'Network/ApiClient';

export const DrugsReqirePreApprovalsAxiosInstance = createApiClient('DrugsPreApproved/');


